export const getCampaignList = {
    GET_CAMPAIGN_LIST_REQUEST: "GET_CAMPAIGN_LIST_REQUEST",
    GET_CAMPAIGN_LIST_REQUEST_AFTER: "GET_CAMPAIGN_LIST_REQUEST_AFTER",
    GET_CAMPAIGN_LIST_SUCCESS: "GET_CAMPAIGN_LIST_SUCCESS",
    GET_CAMPAIGN_LIST_ERROR: "GET_CAMPAIGN_LIST_ERROR",
};
export const getEmailCampaignAnalytics = {
    GET_EMAIL_CAMPAIGN_ANALYTICS_REQUEST: "GET_EMAIL_CAMPAIGN_ANALYTICS_REQUEST",
    GET_EMAIL_CAMPAIGN_ANALYTICS_SUCCESS: "GET_EMAIL_CAMPAIGN_ANALYTICS_SUCCESS",
    GET_EMAIL_CAMPAIGN_ANALYTICS_ERROR: "GET_EMAIL_CAMPAIGN_ANALYTICS_ERROR",
};

export const getEmailCampaignDetailedReport = {
    GET_EMAIL_CAMPAIGN_DETAILED_REPORT_REQUEST: "GET_EMAIL_CAMPAIGN_DETAILED_REPORT_REQUEST",
    GET_EMAIL_CAMPAIGN_DETAILED_REPORT_SUCCESS: "GET_EMAIL_CAMPAIGN_DETAILED_REPORT_SUCCESS",
    GET_EMAIL_CAMPAIGN_DETAILED_REPORT_ERROR: "GET_EMAIL_CAMPAIGN_DETAILED_REPORT_ERROR",
};